import { useState } from "react";
import DateTimePicker from "@react-native-community/datetimepicker";
import { Platform, Pressable, StyleSheet, View } from "react-native";

import { TextField } from "./TextField";
import { maskDateInput } from "~/utils/date-input";

function toDate(value: string) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) return new Date();
  const [, year, month, day] = match;
  return new Date(Number(year), Number(month) - 1, Number(day), 12, 0, 0, 0);
}

function formatDate(value: Date) {
  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, "0");
  const day = String(value.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function DateInput({
  accessibilityLabel,
  onChange,
  placeholder = "YYYY-MM-DD",
  value,
}: {
  accessibilityLabel?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  value: string;
}) {
  const [showPicker, setShowPicker] = useState(false);

  if (Platform.OS === "web") {
    return (
      <TextField
        accessibilityLabel={accessibilityLabel}
        inputMode="numeric"
        maxLength={10}
        placeholder={placeholder}
        value={value}
        onChangeText={(nextValue) => onChange(maskDateInput(nextValue))}
      />
    );
  }

  return (
    <View>
      <Pressable onPress={() => setShowPicker(true)}>
        <TextField
          accessibilityLabel={accessibilityLabel}
          editable={false}
          pointerEvents="none"
          placeholder={placeholder}
          style={stylesheet.nativeField}
          value={value}
        />
      </Pressable>
      {showPicker ? (
        <DateTimePicker
          mode="date"
          value={toDate(value)}
          onChange={(_, selectedDate) => {
            setShowPicker(false);
            if (selectedDate) onChange(formatDate(selectedDate));
          }}
        />
      ) : null}
    </View>
  );
}

const stylesheet = StyleSheet.create({
  nativeField: { opacity: 1 },
});
